import { render, staticRenderFns } from "./GruposConta.vue?vue&type=template&id=4058acb9&scoped=true&"
import script from "./gruposConta.js?vue&type=script&lang=js&"
export * from "./gruposConta.js?vue&type=script&lang=js&"
import style0 from "./GruposConta.vue?vue&type=style&index=0&id=4058acb9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4058acb9",
  null
  
)

export default component.exports